export default __webpack_public_path__ + "static/media/green_outline_check.6634f469.svg";